import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export function useAddCandidateProject() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, project }) => {
      return axios.post(`/candidate/${candidate.uuid}/project`, project);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data.data
      );
    },
  });
}

export function useUpdateCandidateProject() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, project }) => {
      const formData = new FormData();
      for (const [key, val] of Object.entries(project)) {
        formData.append(key, val);
      }
      // if a new image is uploaded (image_data), remove the image url (image)
      if (formData.has("image_data")) {
        formData.delete("image");
      }
      // if image_data is null, remove it
      if (formData.get("image_data") === "null") {
        formData.delete("image_data");
      }
      formData.append("_method", "PATCH"); // Laravel will treat this as a PATCH request

      return axios.post(
        `/candidate/${candidate.uuid}/project/${project.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data
      );
    },
  });
}

export function useRemoveCandidateProject() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, projectId }) => {
      return axios.delete(`/candidate/${candidate.uuid}/project/${projectId}`);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data
      );
    },
  });
}

export function useReorderCandidateProjects() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, order }) => {
      return axios.post(`/candidate/${candidate.uuid}/projects/reorder`, {
        order,
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data
      );
    },
  });
}
